// extracted by mini-css-extract-plugin
export var chevronIcon = "_60-2";
export var teamName = "_60-1";
export var teamSwitcherButton = "_60-0";